module.exports = __webpack_public_path__ + "img/CF247_Logo_Horizontal_Purple.ee6f3243.svg";